<article class="avatar-upload" [ngClass]="{'width-overlay': isRejected}">
  <core-layout-modal-feedback class="modal-feedback" *ngIf="isRejected" [type]="'fail'"
    [message]="'Error'"
    [text]="'Please upload a valid image file. Supported formats: PNG, JPEG, JPG, GIF'"
    [buttonText]="'Ok'" (action)="dismissRejection()">
  </core-layout-modal-feedback>
  <div class="avatar-upload-content">
      <span class="modal-close" (click)="onCancel()" title="Close">✕</span>
    <header>
      <core-title-section
      [title]="'Upload profile photo'"
      [description]="''"
      ></core-title-section>
    </header>
    <core-storage-files-upload 
      [multiple]="false"
      [allowedTypes]="allowedImageTypes"
      [legacyTempId]="true"
      (response)='upload($event)'
      (onUploading)="uploading($event)"
      (fileRejected)="onFileRejected($event)"
    ></core-storage-files-upload>
  </div>

</article>
